export class RAFTickerEventContext {
    constructor(timestamp, delta) {
        this.timestamp = timestamp;
        this.delta = delta;
    }
}
